import React from 'react';
import styled from 'styled-components';

// Functional component
export const Banner = ({ title, description }) => {
  return (
    <>
      <BannerFrame>
        <TitleFrame>{title}</TitleFrame>
        <DescriptionFrame>{description}</DescriptionFrame>
      </BannerFrame>
    </>
  );
};

// Styled components
const BannerFrame = styled.div`
  background: linear-gradient(270deg, #ffff 0%, #2ac49e 70%, #009e7b 100%);
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 70px 120px;
  margin-bottom: 70px;
  position: relative;

  @media (max-width: 480px) {
    padding: 20px 40px;
    margin-bottom: 35px;
  }
`;

const TitleFrame = styled.div`
  color: #ffff;
  min-height: 32px;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 10px;

  @media (max-width: 480px) {
    font-size: 32px;
  }

  @media (min-width: 768px) {
  }
`;

const DescriptionFrame = styled.div`
  color: #ffff;
  min-height: 16px;
  font-size: 16px;
  font-weight: 600;

  @media (min-width: 375px) {
  }

  @media (min-width: 768px) {
  }
`;

export default Banner;
